/**
 * followUpsApi — thin wrapper over the follow-up endpoints landed in
 * feat/lead-follow-up-backend. Every helper takes plain values and returns
 * the parsed response body; errors are re-thrown so callers can render
 * `formatError(e)` with the existing pattern.
 *
 * Backfill is JSON-body only: `dry_run` and `apply` are mutually
 * exclusive booleans and one of them MUST be true. The server rejects
 * query-string variants, so both helpers post an explicit body.
 */
import { api } from "@/lib/api";

const BASE = "/leads";

export async function listFollowUps({ bucket } = {}) {
  const params = {};
  if (bucket) params.bucket = bucket;
  const { data } = await api.get(`${BASE}/follow-ups`, { params });
  return {
    items: Array.isArray(data?.items) ? data.items : [],
    counts: data?.counts || {
      overdue: 0,
      due_today: 0,
      upcoming: 0,
      unscheduled: 0,
    },
  };
}

export async function completeFollowUp(leadId) {
  const { data } = await api.post(
    `${BASE}/${encodeURIComponent(leadId)}/next-action/complete`,
  );
  return data;
}

export async function snoozeFollowUp(leadId, untilISO) {
  const { data } = await api.post(
    `${BASE}/${encodeURIComponent(leadId)}/next-action/snooze`,
    { until: untilISO },
  );
  return data;
}

export async function dismissFollowUp(leadId) {
  const { data } = await api.post(
    `${BASE}/${encodeURIComponent(leadId)}/next-action/dismiss`,
  );
  return data;
}

export async function previewFollowUpBackfill() {
  const { data } = await api.post("/admin/lead-follow-ups/backfill", {
    dry_run: true,
    apply: false,
  });
  return data;
}

export async function applyFollowUpBackfill() {
  const { data } = await api.post("/admin/lead-follow-ups/backfill", {
    dry_run: false,
    apply: true,
  });
  return data;
}
